import { FileText, Layers, Upload, Zap } from 'lucide-react'
import { useI18n } from '../../lib/i18n/i18n-store'
import { useLoadStarter } from '../../hooks/useStarterPack'

import './EmptyState.css'

/**
 * Inicio with no decks — the first thing a new user sees. The main action
 * loads the starter example (a deck and a note, hooks/useStarterPack.ts) so
 * there is something to study from the first minute; importing their own
 * cards is the second. Nothing is loaded until the button is pressed, and the
 * page says up front that the example syncs like any other deck.
 */
export function EmptyState({ onImport }: { onImport: () => void }) {
  const { t } = useI18n()
  const loadStarter = useLoadStarter()
  const busy = loadStarter.isPending

  return (
    <section className="es-wrap" aria-labelledby="es-title">
      <Zap size={28} className="es-mark" aria-hidden="true" />
      <h1 id="es-title" className="es-title">{t('starter.empty.title')}</h1>
      <p className="es-lead">{t('starter.empty.lead')}</p>

      <ul className="panel es-contents" aria-label={t('starter.contentsLabel')}>
        <li className="es-item">
          <Layers size={16} className="es-item-icon" aria-hidden="true" />
          <span>{t('starter.empty.deck')}</span>
        </li>
        <li className="es-item">
          <FileText size={16} className="es-item-icon" aria-hidden="true" />
          <span>{t('starter.empty.note')}</span>
        </li>
      </ul>

      <div className="es-actions">
        <button
          type="button"
          className="btn btn--lg btn--primary es-btn es-btn--primary"
          onClick={() => loadStarter.mutate()}
          disabled={busy}
          aria-busy={busy}
        >
          {busy ? t('starter.loading') : t('starter.load')}
        </button>
        <button type="button" className="btn btn--lg es-btn" onClick={onImport} disabled={busy}>
          <Upload size={14} aria-hidden="true" />
          {t('starter.import')}
        </button>
      </div>

      <p className="es-fine">{t('starter.syncNotice')}</p>
      <p className="es-fine">{t('starter.empty.formats')}</p>
    </section>
  )
}
